<template>
  <div class="">
    <button v-if="documents.length" class="btn btn-link text-primary text-decoration-none font-weight-bold" @click="toggleSelectAllDocuments">{{ allDocumentsSelected ? 'Unselect all document' : 'Select all document' }}</button>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Filename</th>
            <th class="text-left">Case Name</th>
            <th class="text-left">Uploaded</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3" class="primary--text">
              <v-icon small color="primary">mdi-upload-outline</v-icon>
              <h5 color="primary" @click="openUpload" class="hover ml-1">
                Upload File
              </h5>
              <UploadDocumentModal :dialog="dialogUpload" @toggle-modal="toggleDialog"/>
            </td>
          </tr>
          <Row v-for="file in documents" :key="file.id" :file="file" :isSelected="isSelected(file.id)" @toggle-selection="handleToggleSelection" />
          <BottomActionBar v-if="selectedDocuments.length" :selected-documents="selectedDocuments" @clear-selection="clearSelection" />
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import Row from './row.vue'
import BottomActionBar from './bottom_action_bar.vue';
import UploadDocumentModal from './upload-document-modal.vue';

export default {
  components: { Row, BottomActionBar, UploadDocumentModal },
  data: function() {
    return {
      dialogUpload: false,
      selectedDocuments: [],
    }
  },
  computed: {
    documents() {
      return this.$store.state.documents
    },
    org_id() {
      return this.$store.state.organization.id
    },
    allDocumentsSelected() {
      return this.selectedDocuments.length === this.documents.length;
    }
  },
  methods: {
    openUpload() {
      this.dialogUpload = true
    },
    toggleSelectAllDocuments() {
      this.selectedDocuments = this.allDocumentsSelected ? [] : this.documents.map(file => file.id);
    },
    toggleDialog(payload) {
      this.dialogUpload = payload
    },
    handleToggleSelection(fileId, isSelected) {
      if (isSelected) {
        this.selectedDocuments?.push(fileId);
      } else {
        this.selectedDocuments = this.selectedDocuments?.filter(id => id !== fileId);
      }
    },
    isSelected(fileId) {
      return this.selectedDocuments?.includes(fileId);
    },
    clearSelection() {
      this.selectedDocuments = [];
    }
  }
}
</script>

<style lang="scss">
  .hover {
    &:hover {
      cursor: pointer
    }
  }
</style>
